import React, { useState, useEffect } from 'react'

export default function Navigation() {
    const [isOpen, setIsOpen] = useState(false);  
    const [activePath, setActivePath] = useState(window.location.pathname);


    const openSidebarClick = () => {
        setIsOpen(!isOpen);
        const sidebar = document.querySelector('.sidebar')
        const plusbutton = document.querySelector('.plusbutton')

        if (!isOpen) {
            sidebar.style.display = 'flex'; // Open sidebar
        } else {
            sidebar.style.display = 'none'; // Close sidebar
        }
    }; 

    const hideSidebarClick = () => {
        setIsOpen(false);
        const sidebar = document.querySelector('.sidebar')
        const plusbutton = document.querySelector('.plusbutton')
        sidebar.style.display = 'none'
    }; 
      
    const handleLinkClick = () => {
        setIsOpen(false); // Close the navigation when a link is clicked
        const sidebar = document.querySelector('.sidebar');
        sidebar.style.display = 'none'; // Ensure sidebar is hidden
    };

    // Handle window resize
    const handleResize = () => {
        if (window.innerWidth > 620) {  // When window width is larger than 650px
            setIsOpen(false); // Close sidebar if open
            const sidebar = document.querySelector('.sidebar');
            const plusbutton = document.querySelector('.plusbutton')
            sidebar.style.display = 'none'; // Hide the sidebar
        }
    };

    // Use useEffect to add and clean up the resize event listener
    useEffect(() => {
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Keep activePath in sync with the actual URL
    useEffect(() => {
        const updatePath = () => setActivePath(window.location.pathname);
        window.addEventListener('popstate', updatePath);

        // Also catch regular link clicks that change the URL
        const observer = new MutationObserver(() => {
            if (window.location.pathname !== activePath) {
                setActivePath(window.location.pathname);
            }
        });
        observer.observe(document.querySelector('#root'), { childList: true, subtree: true });

        return () => {
            window.removeEventListener('popstate', updatePath);
            observer.disconnect();
        };
    }, []);

    const isActive = (path) => {
        if (path === '/') return activePath === '/';
        return activePath.startsWith(path);
    };

    const handleNavClick = (path) => {
        setActivePath(path);
        handleLinkClick();
    };
    
  return (
    <div className='sticky-header'>
        <header>
            <nav>
                <a href="/" className="nav-name" onClick={() => handleNavClick('/')}>
                    <span>andranik</span>
                    <span>aristakesyan</span>
                </a>

                {/* Sidebar */}
                <ul className={"sidebar"}>
                    <li className={"close"} onClick={hideSidebarClick}>
                        <a href='#'>
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                height="48px" 
                                viewBox="0 -960 960 960" 
                                width="48px" 
                                fill="currentColor"
                            >
                                <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="/about" className={isActive('/about') ? 'nav-active' : ''} onClick={() => handleNavClick('/about')}> about </a>
                    </li>
                    <li>
                        <a href="/projects" className={isActive('/projects') ? 'nav-active' : ''} onClick={() => handleNavClick('/projects')}> projects </a>
                    </li>
                    <li>
                        <a href="/articles" className={isActive('/articles') ? 'nav-active' : ''} onClick={() => handleNavClick('/articles')}> articles </a>
                    </li>
                </ul>
    
                {/* Main Menu */}
                <ul>
                    <li className='hideOnMobile'>
                        <a href="/about" className={isActive('/about') ? 'nav-active' : ''} onClick={() => handleNavClick('/about')}> about </a>
                    </li>
                    <li className='hideOnMobile'>
                        <a href="/projects" className={isActive('/projects') ? 'nav-active' : ''} onClick={() => handleNavClick('/projects')}> projects </a>
                    </li>
                    <li className='hideOnMobile'>
                        <a href="/articles" className={isActive('/articles') ? 'nav-active' : ''} onClick={() => handleNavClick('/articles')}> articles </a>
                    </li>
                    <li className='plusbutton' onClick={openSidebarClick}>
                        <a href="#">  
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                height="48px" 
                                viewBox="0 -960 960 960" 
                                width="48px" 
                                fill="currentColor"
                            >
                                <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"/>
                            </svg>
                        </a>
                    </li>
                </ul>
            </nav>
        </header>
    </div>
  )
}
